import React, { useEffect } from "react";
import { Select, Space, Grid } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/en";
import "dayjs/locale/es";
import "dayjs/locale/ar";
import "dayjs/locale/pl";
import "dayjs/locale/ca";
import "dayjs/locale/mn";
import "dayjs/locale/ru";
import "dayjs/locale/uk";
import "dayjs/locale/zh";
const { useBreakpoint } = Grid;

const DateOfBirth = (props: any) => {
  const { handleDateChange, language } = props;

  const screens = useBreakpoint();
  let currentLanguage = language;
  if (currentLanguage === "rs") {
    currentLanguage = "ru";
  } else if (currentLanguage === "ur") {
    currentLanguage = "uk";
  } else if (currentLanguage === "ch") {
    currentLanguage = "zh";
  }
  useEffect(() => {
    if (currentLanguage === "ru") {
      dayjs.locale("ru");
    }
     if (currentLanguage === "uk") {
       dayjs.locale("uk");
     }
       if (currentLanguage === "zh") {
         dayjs.locale("zh");
       }
  }, [currentLanguage]); 
  useEffect(() => {
    if (language) {
      dayjs.locale(language);
    }
  }, [language]);

  function displayFirstThreeWords(text: string) {
    if (!text) return text;
    const words = text.split("");
    const firstThreeWords = words.slice(0, 3);
    const result = firstThreeWords.join("");
    return result;
  }

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase());

  const onSearch = (value: string) => {
    console.log("search:", value);
  };

  const getMonths = () => {
    const allMonths = Array.from({ length: 12 }, (_, i) => i + 1).map(
      (month) => {
        let monthName = dayjs()
          .month(month - 1)
          .format("MMMM");
        console.log("monthName", monthName);
        return {
          key: month,
          value: month.toString(),
          label: displayFirstThreeWords(monthName),
        };
      }
    );
    return allMonths;
  };

  const getMonthByKey = (keyValue: any) => {
    const months = getMonths();
    const monthObj = months.find((month) => month.value === keyValue);
    return monthObj ? monthObj.label : undefined;
  };

  console.log("props", props);
  return (
    <div data-testid="input-dob">
      <Space>
        <Select
          showSearch
          onSearch={onSearch}
          filterOption={filterOption}
          data-testid="dob-mnth"
          onChange={(date) => handleDateChange(date, 0)}
          value={props?.dob && props?.dob[0] ? getMonthByKey(props.dob[0]) : ""}
          style={{
            width: screens.md ? 120 : 80,
            height: 38,
            fontWeight: "bold",
          }}
          options={getMonths()}
        />
        <Select
          data-testid="dob-date"
          onChange={(date) => handleDateChange(date, 1)}
          style={{
            width: screens.md ? 120 : 80,
            height: 38,
            fontWeight: "bold",
          }}
          value={props?.dob && props.dob[1] ? props.dob[1] : ""}
          showSearch
          onSearch={onSearch}
          filterOption={filterOption}
          options={Array.from({ length: 31 }, (_, i) => i + 1).map((day) => {
            return {
              key: day.toString(),
              value: day.toString(),
              label: displayFirstThreeWords(day.toString()),
            };
          })}
        />
        <Select
          data-testid="dob-year"
          onChange={(date) => handleDateChange(date, 2)}
          value={props?.dob && props.dob[2] ? props.dob[2] : ""}
          style={{
            width: screens.md ? 120 : 80,
            height: 38,
            fontWeight: "bold",
          }}
          showSearch
          onSearch={onSearch}
          filterOption={filterOption}
          options={Array.from(
            { length: 100 },
            (_, i) => dayjs().year() - i
          ).map((year) => {
            return {
              key: year.toString(),
              value: year.toString(),
              label: year.toString(),
            };
          })}
        />
      </Space>
    </div>
  );
};

export default DateOfBirth;
